<div class="row" (keydown.enter)="$event.preventDefault()">
  <div style="min-height: 25vh;" id="dropzone" (dragover)="onFileDrag($event)" (drop)="onFileDrop($event, selectionType)"
       class="d-flex flex-column p-5 {{uploadedFiles && uploadedFiles.length === 0 && 'file-upload-border rounded'}} justify-content-center align-items-center col-md-12">
    <div *ngIf="uploadedFiles && uploadedFiles.length === 0" class="flex-column text-center p-5 w-100">
      <button type="button" mat-raised-button class="rounded" (click)="fileInput.click()">
        <i-tabler name="upload" class="icon-20 d-flex"></i-tabler>
      </button>
      <p class="mt-2">{{'FileUploadArea.dragAndDrop' | localize}}</p>
      <p class="mt-2">{{'FileUploadArea.maxFileSize' | localize}} {{maxFileSize}}</p>
      <input
        type="file"
        [multiple]="!isExcelFile()"
        hidden
        #fileInput
        [accept]="acceptedTypes"
        (change)="uploadFiles(fileInput.files, selectionType)"/>
      <p class="mt-2">{{'FileUploadArea.acceptedTypes' | localize}} {{loadableFileTypes}}</p>
    </div>
    <div *ngIf="uploadedFiles && uploadedFiles.length > 0" class="container position-relative w-100 h-100">
      <p class="position-absolute top-0 start-0">{{'FileUploadArea.uploadedFiles' | localize}}</p>
      <div class="row mt-4">
        @if (selectionType == "document") {
          @for (file of uploadedFiles; track $index) {
            <div class="col-md-4 col-sm-6 col-12 p-2">
              <div class="bg-light p-4 d-flex justify-content-between align-items-center rounded shadow-sm">
                <i-tabler name="{{getFileMimeTypeIcon(file)}}" style="color: var(--mat-sys-primary)"></i-tabler>
                <span class="text-truncate file-name" matTooltip="{{file.name}}">{{ file.name }}</span>
                <button mat-icon-button (click)="removeUploadedFile($index, 'document')"
                        class="ms-2 d-flex align-items-center px-2 py-1">
                  <i-tabler name="trash-x" style="color: red;"></i-tabler>
                </button>
              </div>
            </div>
          }
        } @else if (selectionType == "multimedia")  {
          @for (file of uploadedFilesWithUrl; track $index) {
            <div class="col-md-3 col-sm-4 col-6 p-5">
              <div class="d-flex flex-column justify-content-between align-items-center p-5 bg-light h-100 rounded border-primary">
                <div class="d-flex justify-content-center align-items-center">
                  @if (getFileMimeTypeIcon(file.file) == "photo-scan") {
                    <img draggable="false" style="min-width: 16rem; max-width: 16rem; max-height: 16rem; min-height: 16rem; object-fit: contain;" mat-card-image [src]="file.url" class="w-100 p-4" alt="{{file.file.name}}">
                  } @else if (getFileMimeTypeIcon(file.file) == "video") {
                    <video draggable="false" style="min-width: 16rem; max-width: 16rem; max-height: 16rem; min-height: 16rem; object-fit: contain;" mat-card-image class="w-100 p-4" [src]="file.url" controls></video>
                  }
                </div>
                <div class="w-100 d-flex justify-content-between align-items-center p-5">
                  <div style="max-width: 75%;" class="d-flex align-items-center gap-2 flex-1-auto">
                    <i-tabler name="{{getFileMimeTypeIcon(file.file)}}" style="color: var(--mat-sys-primary)"></i-tabler>
                    <span matTooltip="{{file.file.name}}" class="text-truncate d-inline-block file-name">{{file.file.name}}</span>
                  </div>
                  <button mat-icon-button (click)="removeUploadedFile($index, selectionType)" class="ms-2 d-flex align-items-center px-2 py-1">
                    <i-tabler name="trash-x" style="color: red;"></i-tabler>
                  </button>
                </div>
              </div>
            </div>
          }
        } @else if (selectionType === "table"){
          @if (uploadedFiles.length > 0) {
            <div class="d-flex flex-column justify-content-center align-items-center w-100">
              <div class="w-100 d-flex justify-content-between align-items-start">
                <div class="col-md-4 col-sm-6 col-12 p-2">
                  <div class="bg-light p-4 d-flex justify-content-between align-items-center rounded shadow-sm">
                    <i-tabler name="{{getFileMimeTypeIcon(uploadedFiles[0])}}" style="color: var(--mat-sys-primary)"></i-tabler>
                    <span class="text-truncate file-name" matTooltip="{{uploadedFiles[0].name}}">{{ uploadedFiles[0].name }}</span>
                    <button mat-icon-button (click)="removeUploadedFile(0, 'table')"
                            class="ms-2 d-flex align-items-center px-2 py-1">
                      <i-tabler name="trash-x" style="color: red;"></i-tabler>
                    </button>
                  </div>
                </div>
              </div>
              @if (uploadedFiles.length > 0) {
                <app-excel-table *ngIf="!loading && sheetData.length > 0; else tableSpinner" class="w-100 p-5"
                                 [excelData]="sheetData"
                                 [uploadedFilesLength]="uploadedFiles.length"
                                 [formGroup]="formGroup"
                                 (userDecisionChangeEvent)="changeUserDecision($event[0], $event[1], $event[2])"
                                 [getOptionTypeIcon]="getOptionTypeIcon"
                                 (sheetHeaderChangeEvent)="updateSheetHeaderKey($event[0], $event[1], $event[2])"
                >
                </app-excel-table>
                <ng-template #tableSpinner>
                  <div style="flex-direction: column" class="d-flex justify-content-center align-items-center">
                    <mat-spinner diameter="40"></mat-spinner>
                    <p>{{'FileUploadArea.readingSheets' | localize}}</p>
                  </div>
                </ng-template>
              }
            </div>
          }
        } @else if (selectionType === "organization") {
          @if (uploadedFiles.length > 0) {
          <div class="d-flex flex-column justify-content-center align-items-center w-100">
            <div class="w-100 d-flex justify-content-between align-items-start">
              <div class="col-md-4 col-sm-6 col-12 p-2">
                <div class="bg-light p-4 d-flex justify-content-between align-items-center rounded shadow-sm">
                  <i-tabler name="{{getFileMimeTypeIcon(uploadedFiles[0])}}" style="color: var(--mat-sys-primary)"></i-tabler>
                  <span class="text-truncate file-name" matTooltip="{{uploadedFiles[0].name}}">{{ uploadedFiles[0].name }}</span>
                  <button mat-icon-button (click)="removeUploadedFile(0, 'excel')"
                          class="ms-2 d-flex align-items-center px-2 py-1">
                    <i-tabler name="trash-x" style="color: red;"></i-tabler>
                  </button>
                </div>
              </div>
            </div>
            <div style="flex-direction: column;" class="d-flex justify-content-center align-items-start w-100 p-l-5 p-t-10">
              <mat-form-field appearance="outline">
                <mat-label>
                  {{'FileUploadArea.divisionType' | localize}}
                </mat-label>
                <mat-select (selectionChange)="selectDivisionType($any($event.value))">
                  @for (type of divisionTypes; track type.toString()) {
                    <mat-option [value]="type">
                      {{ type }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
              <app-excel-table class="w-100 p-5"
                               *ngIf="!loading && sheetData.length > 0; else organizationSpinner"
                               [excelData]="sheetData"
                               [uploadedFilesLength]="uploadedFiles.length"
                               [formGroup]="formGroup"
                               [getOptionTypeIcon]="getOptionTypeIcon"
                               [selectedDivisionType]="selectedDivisionType"
                               (userDecisionChangeEvent)="changeUserDecision($event[0], $event[1], $event[2])"
                               (columnMappingsChange)="addColumnMappings($event[0], $event[1], $event[2], $event[3])"
                               (updateDivisionColumnsChange)="updateDivisionColumns($event)"
                               [selectedColumns]="selectedColumns"
              >
              </app-excel-table>
              <ng-template #organizationSpinner>
                <div style="flex-direction: column" class="d-flex justify-content-center align-items-center">
                  <mat-spinner diameter="40"></mat-spinner>
                  <p>{{'FileUploadArea.readingSheets' | localize}}</p>
                </div>
              </ng-template>
                      </div>
          }
        } @else if (selectionType === "qa") {
          <div class="w-100">
            <app-qa-input 
              [formGroup]="formGroup"
              (qaDataChange)="onQaDataChange($event)"
              (fileUploadEvent)="onQaFileUpload($event)">
            </app-qa-input>
          </div>
        }
      </div>
    </div>
  </div>
  <div *ngIf="(selectionType !== 'table' && selectionType !== 'organization' && selectionType !== 'qa') && uploadedFiles.length > 0" style="flex-direction: column;"
       class="w-100 d-flex justify-content-center align-items-center">
    <button style="margin-bottom: 1rem;" type="button" mat-raised-button class="rounded" (click)="fileInput.click()">
      <i-tabler name="upload" class="icon-20 d-flex"></i-tabler>
    </button>
    <span>{{'FileUploadArea.addMoreFile' | localize}}</span>
    <input
      type="file"
      [multiple]="!isExcelFile()"
      hidden
      #fileInput
      [accept]="acceptedTypes"
      (change)="uploadFiles(fileInput.files, selectionType)"/>
  </div>
  <div class="w-100" *ngIf="selectionType !== 'table' && selectionType !== 'organization' && selectionType !== 'qa'">
    <app-user-decision-options *ngIf="uploadedFiles.length"
         [uploadedFilesLength]="uploadedFiles.length"
         [formGroup]="formGroup"
         [uploadedFiles]="uploadedFiles"
         (userDecisionChange)="changeUserDecision($event[0], $event[1], $event[2])"
         [getOptionTypeIcon]="getOptionTypeIcon">
    </app-user-decision-options>
  </div>
</div>
